(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spin-launch"] && !Shopify.designMode) return;
  try {
    
function initializeSpinLaunch(root){
  const menu=root.querySelector('.spin-mobile-menu');
  if(menu&&!menu.dataset.ready){
    menu.dataset.ready='true';
    menu.addEventListener('click',event=>{if(event.target.closest('a'))menu.open=false;});
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
  }
  if(!root.dataset.navigationReady){
    root.dataset.navigationReady='true';
    root.addEventListener('click',event=>{if(event.target.closest('a[href="#how-to-draw"]'))root.querySelector('#how-to-draw > details').open=true;});
  }
  const button=root.querySelector('.spin-turn');
  const skip=root.querySelector('.spin-skip-motion');
  const dial=root.querySelector('.spin-small-dial .spin-dial');
  const guideButtons=root.querySelectorAll('[data-guide-mode]');
  if(button&&skip&&dial&&!button.dataset.ready){
    button.dataset.ready='true';
    const ids=['ritual-outer_22_locked_r2','ritual-middle_14_locked_king_r6','ritual-inner_4_locked_r9'];
    const counts=[22,14,4];
    const groups=ids.map(id=>dial.querySelector('[id="'+id+'"]'));
    const result=root.querySelector('.spin-result');
    const status=result.querySelector('.spin-result-status');
    const modes=Array.from(root.querySelectorAll('[data-practice-mode]'));
    const allModes=[...modes,...guideButtons];
    const syncModes=()=>{
      const locked=stage!=='ready'&&stage!=='complete';
      allModes.forEach(item=>{item.disabled=locked;item.setAttribute('aria-pressed',String(Number(item.dataset.practiceMode||item.dataset.guideMode)===mode));});
      root.querySelectorAll('[data-guide-panel]').forEach(panel=>panel.hidden=Number(panel.dataset.guidePanel)!==mode);
      root.querySelector('[data-guide-lock]').hidden=!locked;
    };
    const resetButton=root.querySelector('.spin-start-again');
    const modeHint=root.querySelector('.spin-mode-hint');
    const labels=Object.fromEntries(Array.from(root.querySelectorAll('[data-draw-label]'),item=>[item.dataset.drawLabel,item.textContent.trim()]));
    const names=selector=>Array.from(result.querySelectorAll(selector),item=>item.textContent.trim());
    const majorNames=names('[data-spin-major]');
    const rankNames=names('[data-spin-rank]');
    const suitNames=names('[data-spin-suit]');
    const majorResult=result.querySelector('[data-spin-major-result]');
    const minorResult=result.querySelector('[data-spin-minor-result]');
    const partsResult=result.querySelector('[data-spin-parts-result]');
    const actionResult=result.querySelector('[data-spin-action-result]');
    const actionParts=result.querySelector('[data-spin-action-parts]');
    const actionRow=result.querySelector('[data-action-row]');
    const repeatNote=result.querySelector('.spin-repeat-note');
    const symbolResults=['major','minor','action'].map(name=>result.querySelector('[data-symbol-result="'+name+'"]'));
    const rankIds=['rank_a','rank_ii','rank_iii','rank_iv','rank_v','rank_vi','rank_vii','rank_viii','rank_ix','rank_x','court_page','court_knight','court_queen','court_king'];
    const suitIds=['suit_wand','suit_cup','suit_sword','suit_pentacle'];
    const symbolSources=[
      Array.from({length:22},(_,index)=>groups[0].querySelector('[id^="ritual-CARD_'+String(index).padStart(2,'0')+'_"]')),
      rankIds.map(id=>groups[1].querySelector('[id="ritual-'+id+'"]')),
      suitIds.map(id=>groups[2].querySelector('[id="ritual-'+id+'"]'))
    ];
    const homeAngles=[-8.181818182,-64.285714,180];
    // Exact transformed path bounds; generated from the preserved SVG sources.
    const symbolBounds=[[[-1.9600001,-20.47000003,3.92000008,5.31000005],[-2.05000014,-20.68000008,4.0999999,5.82000018],[-2.15169801,-20.53786071,4.30339538,5.33786068],[-1.97212543,-20.59013316,3.94425,5.79013321],[-2.00721808,-20.62713099,4.01443502,5.77713111],[-1.8584577,-20.57195153,3.71691409,5.70195168],[-1.91254721,-20.49000004,3.82509486,5.72000006],[-1.95054207,-20.30999994,3.90108224,4.94000014],[-2.05000102,-20.68000012,4.0999999,5.85200008],[-1.29800111,-20.5884251,2.59599996,5.3546252],[-1.96000124,-20.23000002,3.92000008,4.51999998],[-2.00007457,-20.54023028,4.00027251,5.23999024],[-2.0502011,-20.37021484,4.10000825,5.30045168],[-1.87000163,-20.69000006,3.74000001,5.92000008],[-1.64530438,-20.59337052,2.85206611,5.81450443],[-1.91906739,-20.59990664,3.83825688,5.85975619],[-2.08132335,-20.59563994,4.16264248,5.74564016],[-1.89000447,-20.02987902,3.7801311,4.31984489],[-1.41856035,-20.32442231,2.83711626,5.14884487],[-1.86000221,-20.08999991,3.72000003,4.67999983],[-1.92949421,-20.64123259,3.90143343,5.84755684],[-1.75000242,-20.72999976,3.5,5.95999952]],[[-1.42008112,-11.67999975,2.84016223,3.53008087],[-0.89999996,-11.6,1.80000001,3.20000001],[-1.49999991,-11.60000001,3.00000003,3.20000002],[-1.54000003,-11.60007998,3.36007997,3.20007998],[-1.06007995,-11.60007998,2.12015995,3.05007973],[-0.88007703,-12.32507712,1.76015424,4.40007712],[-0.8999999,-12.32507713,1.80000002,4.40007713],[-1.5,-12.52507178,3.0,4.30007178],[-0.8600027,-12.325,1.72000548,4.30000274],[-0.84007833,-11.60007842,1.68015685,3.20015684],[-1.63232963,-11.88315552,3.26465923,3.76631102],[-1.28600012,-12.05,2.57200029,4.15999975],[-1.52682119,-12.02825681,3.05364254,4.20375655],[-1.60999986,-12.18,3.22,4.30800001]],[[-0.55,-5.275,1.1,3.45],[-1.08125,-5.175,2.1625,3.25],[-1.2,-5.235,2.4,3.37],[-1.5,-5.05,3.0,3.0]]];
    const renderSymbols=(container,selections)=>{
      container.replaceChildren();container.hidden=false;
      selections.forEach(([layer,slot],index)=>{
        if(index){const plus=document.createElement('span');plus.className='spin-symbol-plus';plus.textContent='+';container.append(plus);}
        const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
        svg.setAttribute('class','spin-result-symbol');svg.setAttribute('focusable','false');
        svg.dataset.symbolLayer=String(layer);svg.dataset.symbolSlot=String(slot);
        const box=document.createElementNS(svg.namespaceURI,'g');
        const pose=document.createElementNS(svg.namespaceURI,'g');
        pose.setAttribute('transform','rotate('+(homeAngles[layer]-slot*360/counts[layer])+')');
        const source=symbolSources[layer][slot];
        if(!source)return;
        const copy=source.cloneNode(true);copy.removeAttribute('id');copy.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
        pose.append(copy);box.append(pose);svg.append(box);container.append(svg);
        const [x,y,width,height]=symbolBounds[layer][slot];
        const padding=height*.1, viewportHeight=height+2*padding, viewportWidth=width+2*padding;
        svg.setAttribute('viewBox',[x-padding,y-padding,viewportWidth,viewportHeight].join(' '));
        svg.style.setProperty('--symbol-ratio',String(viewportWidth/viewportHeight));
      });
    };
    const angles=[0,0,0];
    const slots=[0,0,0];
    let mode=2, stage='ready', frame=0, running=false, targets=[], firstMinor='';
    const normalize=angle=>((angle%360)+360)%360;
    const setStage=value=>{stage=value;syncModes();result.dataset.stage=value;modeHint.textContent=value==='complete'?labels.mode_complete:(value==='ready'?labels.mode_hint:labels.mode_locked);};
    const reset=(preservePose=false)=>{
      cancelAnimationFrame(frame);
      running=false;targets=[];firstMinor='';setStage('ready');
      symbolResults.forEach(container=>{container.replaceChildren();container.hidden=true;});
      if(!preservePose)groups.forEach((group,index)=>{angles[index]=0;slots[index]=0;group.style.transform='rotate(0deg)';group.dataset.spinSlot='0';});
      majorResult.textContent=labels.pending;minorResult.textContent=labels.pending;partsResult.textContent='';
      actionResult.textContent=labels.action_pending;actionParts.textContent='';actionRow.hidden=mode!==3;repeatNote.hidden=true;
      status.textContent=mode===2?labels.ready_two:labels.ready_three;
      modes.forEach(item=>{item.disabled=false;item.setAttribute('aria-pressed',String(Number(item.dataset.practiceMode)===mode));});
      button.hidden=false;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=labels.start;
      skip.hidden=true;resetButton.hidden=true;dial.dataset.spinState='idle';
    };
    const finish=()=>{
      if(!running)return;
      cancelAnimationFrame(frame);
      groups.forEach((group,index)=>{angles[index]=targets[index].angle;slots[index]=targets[index].slot;group.style.transform=`rotate(${angles[index]}deg)`;});
      const rank=rankNames[slots[1]],suit=suitNames[slots[2]];
      const format=pattern=>pattern.replace('__RANK__',rank).replace('__SUIT__',suit);
      const minor=format(result.dataset.minorPattern),parts=format(result.dataset.partsPattern);
      if(stage==='first'){
        renderSymbols(symbolResults[0],[[0,slots[0]]]);renderSymbols(symbolResults[1],[[1,slots[1]],[2,slots[2]]]);
        majorResult.textContent=majorNames[slots[0]];minorResult.textContent=minor;partsResult.textContent=parts;firstMinor=minor;
        setStage(mode===3?'awaiting_action':'complete');
        status.textContent=mode===3?labels.second_ready:labels.done_two;
      }else{
        renderSymbols(symbolResults[2],[[1,slots[1]],[2,slots[2]]]);
        actionResult.textContent=minor;actionParts.textContent=parts;repeatNote.hidden=minor!==firstMinor;
        setStage('complete');status.textContent=labels.done_three;
      }
      running=false;dial.dataset.spinState='idle';modes.forEach(item=>item.disabled=stage!=='complete');button.disabled=false;button.removeAttribute('aria-busy');
      button.textContent=stage==='awaiting_action'?labels.next:labels.again;
      const moveFocus=document.activeElement===skip||document.activeElement===button;
      skip.hidden=true;resetButton.hidden=stage==='complete';button.hidden=false;
      if(moveFocus)button.focus({preventScroll:true});
    };
    button.addEventListener('click',()=>{
      if(running||groups.some(group=>!group))return;
      if(stage==='complete')reset(true);
      const second=stage==='awaiting_action';
      setStage(second?'second':'first');
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const direction=Math.random()<.5?-1:1;
      targets=groups.map((group,index)=>{
        group.style.transition='none';
        if(second&&index===0)return {slot:slots[index],angle:angles[index],start:angles[index],travel:0,duration:0};
        const slot=Math.floor(Math.random()*counts[index]),angle=normalize(-slot*360/counts[index]);
        const distance=normalize(direction*(angle-angles[index]));group.dataset.spinSlot=String(slot);
        return {slot,angle,start:angles[index],travel:direction*(360*(reduced?1:2)+distance),duration:(reduced?1800:2800)+index*400};
      });
      status.textContent=second?labels.second_busy:labels.first_busy;
      if(second)actionResult.textContent=button.dataset.busyLabel;
      running=true;dial.dataset.spinState='spinning';
      modes.forEach(item=>item.disabled=true);resetButton.hidden=true;
      button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=button.dataset.busyLabel;skip.hidden=false;
      const started=performance.now();
      const animate=now=>{
        if(!root.isConnected){cancelAnimationFrame(frame);return;}
        let complete=true;
        groups.forEach((group,index)=>{
          const target=targets[index];const progress=target.duration===0?1:Math.min(1,Math.max(0,(now-started)/target.duration));
          complete=complete&&progress===1;
          group.style.transform=`rotate(${target.start+target.travel*(1-Math.pow(1-progress,3))}deg)`;
        });
        if(complete)finish();else frame=requestAnimationFrame(animate);
      };
      frame=requestAnimationFrame(animate);
    });
    allModes.forEach(item=>item.addEventListener('click',()=>{if(running||(stage!=='ready'&&stage!=='complete'))return;const nextMode=Number(item.dataset.practiceMode||item.dataset.guideMode);if(nextMode===mode)return;mode=nextMode;reset();}));
    skip.addEventListener('click',()=>{if(running)finish();});
    resetButton.addEventListener('click',()=>{reset();modes.find(item=>Number(item.dataset.practiceMode)===mode).focus({preventScroll:true});});
    reset();
  }

  const controls=root.querySelectorAll('[data-spin-layer]');
  const guide=root.querySelector('.spin-layer-art .spin-dial');
  const layerIds=['guide-outer_22_locked_r2','guide-middle_14_locked_king_r6','guide-inner_4_locked_r9'];
  controls.forEach(control=>{
    if(control.dataset.ready)return;
    control.dataset.ready='true';
    control.addEventListener('click',()=>{
      const active=control.dataset.spinLayer;
      controls.forEach(item=>item.setAttribute('aria-pressed',String(item===control)));
      if(guide)layerIds.forEach((id,index)=>{const group=guide.querySelector('[id="'+id+'"]');if(group)group.style.opacity=active==='all'||active===String(index)?'1':'.14';});
      root.querySelectorAll('[data-spin-description]').forEach(item=>{item.dataset.active=String(active!=='all'&&active===item.dataset.spinDescription);});
    });
  });
  const success=root.querySelector('.spin-success');
  if(success){success.scrollIntoView({block:'center'});success.focus({preventScroll:true});}
  const errors=root.querySelector('.spin-errors');
  if(errors){errors.setAttribute('tabindex','-1');errors.scrollIntoView({block:'center'});errors.focus({preventScroll:true});}
}
document.querySelectorAll('.spin-site').forEach(initializeSpinLaunch);
document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('.spin-site');if(root)initializeSpinLaunch(root);});

  } catch(e) { console.error(e); }
})();
})();
